import { render } from "./AgencyCommission.vue?vue&type=template&id=b8f37046&scoped=true"
import script from "./AgencyCommission.vue?vue&type=script&lang=js"
export * from "./AgencyCommission.vue?vue&type=script&lang=js"

import "./AgencyCommission.vue?vue&type=style&index=0&id=b8f37046&lang=less&scoped=true"

import exportComponent from "/data/web/pay/agpay/antpay-h5-hengban/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8f37046"]])

export default __exports__